import React, { useCallback, useContext, useMemo } from 'react'
import { navigate } from 'gatsby'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import RocketIcon from '../../../static/assets/icon-rocket.svg'
import ButtonInternalLink from '../Button/ButtonInternalLink'
import LanguageContext from '../../contexts/languageContext'
import { SideMenuContext } from '../../contexts/sideMenuContext'

const HomePageGreeting = ({ userName }) => {
  const { t } = useTranslation()
  const { setSubmenu } = useContext(SideMenuContext)
  const { lang } = useContext(LanguageContext)
  const link = useMemo(
    () => ({
      category: 'start',
      path: `/${lang}/start/about/`,
    }),
    [lang]
  )

  const onClickGettingStarted = useCallback(() => {
    setSubmenu(link.category)
    navigate(link.path)
  }, [link, setSubmenu])

  return (
    <div className={`${styles.greetingWrapper} ${styles.homePageWrapper}`}>
      <div className={styles.greetingContent}>
        {userName ? <span>{t('homePage.welcome.greetingLogin', { username: userName })}</span> : <h1>{t('homePage.welcome.greeting')}</h1>}
        <h2>{t('homePage.welcome.text')}</h2>
        <ButtonInternalLink type="primary" onClick={onClickGettingStarted}>
          {t('homePage.welcome.startNow')}
        </ButtonInternalLink>
      </div>
      <RocketIcon className={styles.headerBackground} />
    </div>
  )
}

export default HomePageGreeting
